import { GetPsychosocialToolsResponseDTO } from '@/core/dto/psychosocial-report';
import type { GetToolsResponse } from '@/types/Psychosocial';

export class GetToolsMapper {
	constructor(private readonly data: GetPsychosocialToolsResponseDTO) {}

	toDomain(): GetToolsResponse {
		return {
			tools: this.data.tools.map((tool) => ({
				id: tool.id!,
				description: tool.description!
			}))
		};
	}
}
